// The limit of results we want to get/display from dealer-api
export const DEALER_API_RECORDS_LIMIT = 50;
